var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Print")]),_c('Form'),_c('v-btn',{on:{"click":_vm.Test}},[_vm._v("Test")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }